const clientPaymentModes = [
  {
    name: 'GIRO',
    value: 0
  },
  {
    name: 'Cheque',
    value: 1
  }
]

const feedbackFormSections = {
  account_manager: {
    title: 'Account Manager'
  },
  content_curator: {
    title: 'Content & Community Curator'
  },
  client_name: {
    title: 'Client Name'
  },
  campaign_name: {
    title: 'Campaign Name',
    required: true
  },
  good_ratings: {
    headers: [
      {
        text: '',
        width: '75%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Very Poor',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Poor',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Average',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Good',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Very Good',
        width: '5%',
        class: 'no-border',
        align: 'center'
      }
    ],
    fields: [
      {
        title: 'How would you rate your overall experience with Kobe?',
        name: 'overall_experience',
        class: 'background-soft-grey',
        required: true,
        selected: true
      }
    ],
    values: [
      'Very Poor',
      'Poor',
      'Average',
      'Good',
      'Very Good'
    ]
  },
  satisfy_ratings: {
    headers: [
      {
        text: '',
        width: '75%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Very Unsatisfied',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Unsatisfied',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Satisfied',
        width: '5%',
        class: 'no-border',
        align: 'center'
      },
      {
        text: 'Very Satisfied',
        width: '5%',
        class: 'no-border',
        align: 'center'
      }
    ],
    fields: [
      {
        title: 'Selection of Influencers',
        name: 'influencers_selection',
        class: 'background-soft-grey',
        required: true,
        selected: true
      },
      {
        title: 'Responsiveness of Account Managers',
        name: 'am_responsiveness',
        class: '',
        required: true,
        selected: false
      },
      {
        title: 'Recommendation/Insight by Account Managers',
        name: 'am_recommendation',
        class: 'background-soft-grey',
        required: true,
        selected: true
      },
      {
        title: 'Content Quality of the campaign',
        name: 'content_quality',
        class: '',
        required: true,
        selected: false
      },
      {
        title: 'Adhering to Campaign Timeline',
        name: 'campaign_timeline',
        class: 'background-soft-grey',
        required: true,
        selected: true
      }
    ],
    values: [
      'Very Unsatisfied',
      'Unsatisfied',
      'Satisfied',
      'Very Satisfied'
    ]
  },
  // services_appeals: {
  //   title: 'Which of the following KOBE services appeals to you the most?',
  //   name: 'services_appeals',
  //   required: true,
  //   fields: [
  //     {
  //       label: 'Influencers Co-Creation (Storytelling)',
  //       value: 'influencers_cocreation'
  //     },
  //     {
  //       label: 'PR Reviews (Kobe Uncut)',
  //       value: 'pr_reviews'
  //     },
  //     {
  //       label: 'Branded Content Ads (Amplify)',
  //       value: 'branded_contents'
  //     },
  //     {
  //       label: 'Social Media Management',
  //       value: 'social_media'
  //     },
  //     {
  //       label: 'I am not aware of the various services',
  //       value: 'not_aware'
  //     },
  //     {
  //       label: 'None of the above',
  //       value: 'none'
  //     }
  //   ]
  // },
  likely_recommend: {
    headers: [
      {
        text: '',
        width: '75%',
        class: 'no-border',
        align: 'center'
      }
    ],
    fields: [
      {
        title: 'How likely is it that you would recommend Kobe to friends or colleagues?',
        name: 'likely_recommend',
        caption: '(1 - Least Likely, 10 - Most Likely)',
        class: 'background-soft-grey',
        required: true,
        selected: true
      }
    ]
  },
  what_did_well: {
    title: 'What did Kobe do well?',
    name: 'what_did_well',
    required: true
  },
  what_can_improve: {
    title: 'What can Kobe improve on?',
    name: 'what_can_improve',
    required: true
  },
  // what_you_tell_about_kobe: {
  //   title: 'What would you tell your friends or colleagues about Kobe?',
  //   name: 'what_you_tell_about_kobe',
  //   required: true
  // },
  // what_one_word_in_mind_about_kobe: {
  //   title: 'What is the one word that comes to your mind when you think of Kobe?',
  //   name: 'what_one_word_in_mind_about_kobe',
  //   required: true
  // },
  // kobe_improve_on: {
  //   fields: [
  //     {
  //       label: 'Please rate from 1 to 4:',
  //       name: 'kobe_improve_on',
  //       required: true,
  //       type: 'radio'
  //     }
  //   ],
  //   values: [
  //     'dissatisfactory',
  //     'less than satisfactory',
  //     'satisfactory',
  //     'beyond satisfactory'
  //   ]
  // },
  account_manager_status: {
    rate_title: 'Please rate from 1 to 4:',
    rate_desc: '1: dissatisfactory, 2: less than satisfactory, 3: satisfactory, 4: beyond satisfactory',
    title: 'My Account Manager,',
    name: 'account_manager_status',
    required: true,
    fields: [
      {
        label: 'Dependable',
        name: 'dependable',
        caption: '(He/she understands my needs and i can rely on her for campaign, timeline workflow management)'
      },
      {
        label: 'Initiative',
        name: 'initiative',
        caption: 'he/she has demonstrates pro-activeness and dedication in the campaign'
      },
      {
        label: 'Knowledgeable',
        name: 'knowledgeable',
        caption: 'he/she offers relevant perspectives and insights on influencer/social media'
      }
    ]
  },
  inf_line_up: {
    fields: [
      {
        label: 'Creator line up',
        caption: 'Alignment to my campaign brief and objective:',
        name: 'inf_line_up',
        required: true,
        type: 'radio'
      }
    ],
    values: [
      'little alignment',
      'little to moderate alignment',
      'moderate to strong alignment',
      'strong alignment'
    ]
  },
  inf_content_created: {
    fields: [
      {
        label: 'Creator content created',
        caption: 'Alignment to my campaign brief and objective:',
        name: 'inf_content_created',
        required: true,
        type: 'radio'
      }
    ],
    values: [
      'does not adhere to campaign brief',
      'some adherence to campaign brief, some do not',
      'adheres to campaign brief',
      'beyond adherence to brief, delivers personality and creativity from content creator'
    ]
  },
  sea_countries: {
    title: 'SEA countries that your brand currently / have plans to market in:',
    name: 'sea_countries',
    required: true,
    fields: [
      {
        label: 'Singapore',
        value: 'Singapore',
        type: 'checkbox'
      },
      {
        label: 'Malaysia',
        value: 'Malaysia',
        type: 'checkbox'
      },
      {
        label: 'Indonesia',
        value: 'Indonesia',
        type: 'checkbox'
      },
      {
        label: 'The Philippines',
        value: 'The Philippines',
        type: 'checkbox'
      },
      {
        label: 'Thailand',
        value: 'Thailand',
        type: 'checkbox'
      },
      {
        label: 'Vietnam',
        value: 'Vietnam',
        type: 'checkbox'
      },
      {
        label: 'Others please specify:',
        value: 'other',
        type: 'textfield'
      }
    ]
  },
  platforms: {
    title: 'Social media platforms that your brand currently / have plans to market on:',
    name: 'platforms',
    required: true,
    fields: [
      {
        label: 'Instagram',
        value: 'Instagram',
        type: 'checkbox'
      },
      {
        label: 'Tiktok',
        value: 'Tiktok',
        type: 'checkbox'
      },
      {
        label: 'Youtube',
        value: 'Youtube',
        type: 'checkbox'
      },
      {
        label: 'Xiaohongshu',
        value: 'Xiaohongshu',
        type: 'checkbox'
      },
      {
        label: 'Others please state:',
        value: 'other',
        type: 'textfield'
      }
    ]
  },
  likely_consider_again: {
    headers: [
      {
        text: '',
        width: '75%',
        class: 'no-border',
        align: 'center'
      }
    ],
    fields: [
      {
        title: 'When looking for Influencer Marketing, how likely are you to consider Kobe again?',
        name: 'likely_consider_again',
        caption: '(1 - Least Likely, 10 - Most Likely)',
        class: 'background-soft-grey',
        required: true,
        selected: true
      }
    ]
  },
  kobe_connect: {
    title: 'Can you connect Kobe with others who might benefit from what we do?',
    fields: [
      {
        label: '1',
        name: 'connect_1',
        placeholder: 'Can be email address or contact number',
        type: 'textfield'
      },
      {
        label: '2',
        name: 'connect_2',
        placeholder: '',
        type: 'textfield'
      },
      {
        label: '3',
        name: 'connect_3',
        placeholder: '',
        type: 'textfield'
      }
    ]
  },
  buyagain_decision: {
    title: 'Which of the following would influence your decision the most if you were to buy from Kobe again?',
    name: 'buyagain_decisions',
    required: true,
    fields: [
      {
        label: 'Relevant Targeting',
        value: 'relevant_targeting',
        type: 'checkbox'
      },
      {
        label: 'Competitive Pricing',
        value: 'competitive_pricing',
        type: 'checkbox'
      },
      {
        label: 'Quality of Content',
        value: 'quality_of_content',
        type: 'checkbox'
      },
      {
        label: 'Quality of Influencers',
        value: 'quality_of_influencers',
        type: 'checkbox'
      },
      {
        label: 'Service',
        value: 'service',
        type: 'checkbox'
      },
      {
        label: 'Results',
        value: 'results',
        type: 'checkbox'
      },
      {
        label: 'Hassle-Free Process',
        value: 'hassle_free',
        type: 'checkbox'
      },
      {
        label: 'Other',
        value: 'other',
        type: 'textfield'
      }
    ]
  },
  marketing_challenges: {
    title: 'What other marketing challenges would you like to solve?',
    name: 'marketing_challenges',
    required: true,
    fields: [
      {
        label: 'Brand Awareness',
        value: 'brand_awareness',
        type: 'checkbox'
      },
      {
        label: 'Marketing Budget',
        value: 'marketing_budget',
        type: 'checkbox'
      },
      {
        label: 'Lead Generation',
        value: 'lead_generation',
        type: 'checkbox'
      },
      {
        label: 'Training Marketing Team',
        value: 'training_marketing_team',
        type: 'checkbox'
      },
      {
        label: 'Social Media Content Marketing',
        value: 'social_media_marketing',
        type: 'checkbox'
      },
      {
        label: 'Ideas for Marketing Campaigns',
        value: 'marketing_campaigns_ideas',
        type: 'checkbox'
      },
      {
        label: 'Keeping up with Digital Marketing Trend',
        value: 'digital_marketing_trend',
        type: 'checkbox'
      },
      {
        label: 'Identifying Customers/Target Audience',
        value: 'target_audience',
        type: 'checkbox'
      },
      {
        label: 'Optimising Marketing Platforms (Website, Google, Instagram, Facebook etc)',
        value: 'optimising_marketing_platforms',
        type: 'checkbox'
      },
      {
        label: 'Copywriting',
        value: 'copywriting',
        type: 'checkbox'
      },
      {
        label: 'Proving ROI for Marketing Activities',
        value: 'marketing_activites',
        type: 'checkbox'
      },
      {
        label: 'Other',
        value: 'other',
        type: 'textfield'
      }
    ]
  },
  kobe_questions: {
    fields: [
      // {
      //   label: 'Would you be interested in Kobe coming in to train your team?',
      //   name: 'training_team',
      //   caption: 'Kobe Academy is a new initiative which focuses on educating marketers about the trends and changes in the Social Media and Influencer Marketing industry. This session is complimentary for our clients. Terms and conditions applied. Please ask your Account Manager for details.',
      //   required: true,
      //   type: 'radio'
      // },
      // {
      //   label: 'Would you be open to Kobe sharing the feedback on our marketing collaterals?',
      //   name: 'open_sharing_feedback',
      //   required: true,
      //   type: 'radio'
      // },
      // {
      //   label: 'Would you like to receive our exclusive marketing contents?',
      //   name: 'exclusive_marketing_contents',
      //   required: true,
      //   type: 'radio'
      // },
      {
        label: 'Assuming it is appropriate, would you like for our marketing team to submit this campaign as an award entry?',
        name: 'testimonial_kobe',
        caption: 'Marketing will be in touch for next steps and testimonial.',
        required: true,
        type: 'radio'
      }
    ],
    values: [
      'Yes',
      'No'
    ]
  },
  refer_info: {
    title: 'Refer someone who will find Kobe services useful:',
    fields: [
      {
        label: 'Name',
        name: 'referName',
        type: 'textfield',
        class: 'pr-md-4',
        required: true
      },
      {
        label: 'Company',
        name: 'referCompany',
        type: 'textfield',
        class: 'pr-md-4',
        required: true
      },
      {
        label: 'Contact (number or email for Kobe to contact)',
        name: 'referContact',
        type: 'textfield',
        class: 'pr-md-4',
        required: true
      }
    ]
  },
  contact_info: {
    fields: [
      {
        label: 'Name',
        name: 'name',
        type: 'textfield',
        class: 'pr-md-4',
        required: true
      },
      {
        label: 'Email',
        name: 'email',
        type: 'textfield',
        required: true
      },
      {
        label: 'Company',
        name: 'company',
        type: 'textfield',
        class: 'pr-md-4',
        required: true
      },
      {
        label: 'Designation',
        name: 'designation',
        type: 'textfield',
        required: true
      }
    ]
  }
}

export default Object.assign({}, {
  clientPaymentModes,
  feedbackFormSections
})



// WEBPACK FOOTER //
// ./src/components/views/Client/clientConfig.js